import gql from 'graphql-tag'

export const GET_SHIPPING_CALCULATORS = gql`
query getShippingCalculators($page: Int, $perPage: Int) {
  shippingCalculators(page: $page, perPage: $perPage) {
    nodes {
      id
      shippingType
    }
  }
}

`

export default {
  GET_SHIPPING_CALCULATORS
}
